import { render, staticRenderFns } from "./SiteNotice.vue?vue&type=template&id=033edc84&lang=pug"
import script from "./SiteNotice.vue?vue&type=script&lang=ts"
export * from "./SiteNotice.vue?vue&type=script&lang=ts"
import style0 from "./SiteNotice.vue?vue&type=style&index=0&id=033edc84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports